import { useLocation } from "react-router-dom";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import React, { useState, useEffect } from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { useSelector, useDispatch } from "react-redux";
import Alert from "@mui/material/Alert";
import Fade from "@mui/material/Fade";
import { ArrowBack } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
// import { useHistory } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { columnsHCO } from "./ColumnsHCO";
import { columnsHCP } from "./ColumnsHCP";
import { columnsHCO_External } from "./ColumnsHCO_External";
import { columnsHCP_External } from "./ColumnsHCP_External";

export default function Report() {
  const requestState = useSelector((state) => state.request);
  //const { params,  , selectedUserType, CountryCode } = requestState;

  const location = useLocation();
  const selectedParams = location.state?.selectedParams || {};

  // const history = useHistory();
  const navigate = useNavigate();
  const visibilitModelHCP = {
    id: true,
    mailstatus: true,
    faxstatus: true,
    phonestatus: true,
    wkpemailstatus: true,
    mailingaddresS1: true,
    mailingaddresS2: true,
    mailingaddresS3: true,
    mailingsuburb: true,
    mailingstate: true,
    mailingpostcode: true,
    organisationidL1: true,
    organisationidL2: true,
    organisationidL3: true,
    organisationnameL1: true,
    organisationnameL2: true,
    organisationnameL3: true,
    specialinteresT1: true,
    specialinteresT2: true,
    specialinteresT3: true,
    specialinteresT4: true,
    specialinteresT5: true,
    publicprivate: true,
    addresS1: true,
    addresS2: true,
    addresS3: true,
    specialtY2: true,
    specialtY3: true,
    accountspecialty: true,
    rolE2: true,
  };
  const visibilitModelHCO = {
    id: true,
    mailstatus: true,
    faxstatus: true,
    phonestatus: true,
    wkpemailstatus: true,
    mailingaddresS1: true,
    mailingaddresS2: true,
    mailingaddresS3: true,
    mailingsuburb: true,
    mailingstate: true,
    mailingpostcode: true,
    organisationidL1: true,
    organisationidL2: true,
    organisationidL3: true,
    organisationnameL1: true,
    organisationnameL2: true,
    organisationnameL3: true,
    bannergroupid: true,
    bannergroupname: true,
    addresS2: true,
    addresS3: true,
    publicprivate: true,
    addresS1: true,
  };
  //  const { para } = requestState;
  const { RecordCount, HCPRecords, params, selectedUserType, CountryCode } =
    requestState;

  const { user, isAuthorised } = useSelector((state) => state.authentication);

  useEffect(() => {
    if (!isAuthorised) {
      // history.push("/");
      navigate("/");
    }
  }, [isAuthorised]);

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        {!user.readOnly && <GridToolbarExport />}
      </GridToolbarContainer>
    );
  }

  function GetGridColumns() {
    if (selectedUserType == "HCO") {
      if (user.externalUser) {
        return columnsHCO_External;
      } else {
        return columnsHCO;
      }
    } else {
      if (user.externalUser) {
        return columnsHCP_External;
      } else {
        return columnsHCP;
      }
    }
  }

  return (
    <React.Fragment>
      <div className="col-sm-3" style={{ marginBottom: 20 }}>
        <IconButton
          color="primary"
          aria-label=""
          onClick={() => {
            navigate("/data-extraction-tool/Request",{ state: { preserveState: true } });
            // navigate("/data-extraction-tool/Report", {
            //   state: {
            //     selectedParams: {
            //       IndividualStatusValue,
            //       ActivityStatusValue,
            //       HCPTypeValue,
            //       PrimaryAffilValue,
            //       HCPRole1Value,
            //       HCPRole2Value,
            //       HCOSpecialtyValue,
            //       HCOSectorValue,
            //       MetroCountryValue,
            //       HCOStateValue,
            //       HCOStatusValue,
            //       MailStatusValue,
            //       CallStatusValue,
            //       FaxStatusValue,
            //       EmailStatusValue,
            //       MATSOCValue,
            //       specialty1Value,
            //       specialty2Value,
            //       specialty3Value,
            //       HCPTendancyValue,
            //       HCOTypeValue,
            //     },
            //   },
            // });
          }}
        >
          <ArrowBack />
        </IconButton>
        {/* <Alert severity="info">Records Count: {RecordCount}</Alert> */}
      </div>

      <Container component="main" maxWidth="lg">
      <Stack direction="row" spacing={1} sx={{ marginBottom: 2, flexWrap: "wrap" }}>
          {Object.entries(params).map(([key, value]) => (
            <Chip
              key={key}
              label={`${key}: ${Array.isArray(value) ? value.join(", ") : value}`}
              variant="outlined"
              sx={{ marginBottom: 1 }}
            />
          ))}
        </Stack>
        <Box sx={{ height: 900, width: "100%" }}>
          {/* <DataGrid
               rows={HCPRecords}
               columns={selectedUserType == "HCO" ? columnsHCO : columnsHCP}
                //initialState={{
                //    pagination: {
                 //       paginationModel: {
                 //           pageSize: 100,
                 //       },
                 //   },
                //}}
                columnVisibilityModel={selectedUserType == "HCO" ? visibilitModelHCO: visibilitModelHCP}
                slots={{ toolbar: GridToolbar }} 
              //  pageSizeOptions={[10]}
            /> */}
          <DataGrid
            rows={HCPRecords}
            columns={GetGridColumns()}
            slots={{ toolbar: CustomToolbar }}
            getRowId={(row) => {
              return selectedUserType == "HCO"
              ? `${row.workplaceid}_${row.organisationidL1 || ''}_${row.organisationidL2 || ''}_${row.organisationidL3 || ''}_${row.bannergroupid || ''}`
              : row.hcpuniqueid + row.accountid;
            }}
            // {...HCPRecords}
            initialState={{
              ...HCPRecords?.initialState,
              columns: {
                ...HCPRecords?.initialState?.columns,
                columnVisibilityModel:
                  selectedUserType == "HCO"
                    ? visibilitModelHCO
                    : visibilitModelHCP,
              },
            }}
          />
        </Box>
      </Container>
    </React.Fragment>
  );
}
